import type { RouteRecordRaw } from 'vue-router';

export default <RouteRecordRaw[]>[
  {
    path: 'shelter-settings',
    name: 'admin-shelter-settings',
    component: () => import('./views/ShelterSettings.view.vue'),
  },
];
